import { FC, useEffect } from 'react';
import SurveyDefaultStep from '@/components/SurveyDefaultStep';
import PointsDarkImage from '@/assets/images/points-dark.png';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import analytics from '@/utils/analytics/analyticsInstance';

const YouDidPage: FC = () => {
  const { next } = useSurveyNavigate();

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: 'You did it!',
    });
  }, []);

  return (
    <SurveyDefaultStep
      title={{ value: 'You did it!' }}
      subTitle={{ value: 'You’ve just earned 50 rewards to kickstart your journey.' }}
      image={PointsDarkImage}
      button={{ onClick: next }}
    />
  );
};

export default YouDidPage;
